import { render } from "./bookATestDrive.vue?vue&type=template&id=58631df4"
import script from "./bookATestDrive.vue?vue&type=script&lang=js"
export * from "./bookATestDrive.vue?vue&type=script&lang=js"

import "./bookATestDrive.vue?vue&type=style&index=0&id=58631df4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__